import React from "react";
import "../styles/AboutNextSection.css";

const AboutNextSection = () => {
  return (
    <section className="about-next-section">
        <div className="next-about-container">
      {/* Frame containing text - Now above the image */}
      <div className="next-about-frame">
      <div className="about-text-frame">
        <h2 className="about-heading">Our Services</h2>
        <p className="about-subtext">
          Cjet began with a mission to streamline document delivery <br />processes.
          Over the years, we've grown into a trusted partner for <br />businesses and individuals alike.
        </p>
      </div>

      {/* Image Below */}
      <div className="about-image-container">
        <img src="/about 3.jpg" alt="Our Service" className="about-image" />
      </div>
      </div>
             
        {/* Right Side Container for Stacked Frames */}
        <div className="about-right-container">
       {/* New Tracking Frame */}
       <div className="tracking-frame">
          <h3 className="tracking-title">Real-Time Tracking</h3>
          <p className="tracking-text">
            Stay updated on your package's journey with <br/>live tracking features.
          </p>
        </div>
           {/* Secure Handling Frame (New Frame Below Tracking) */}
           <div className="secure-frame">
            <h3 className="secure-title">Secure Handling</h3>
            <p className="secure-text">
              Your items are treated with utmost care, <br />guaranteeing safe delivery.
            </p>
          </div>

          {/* Timely Delivery Frame (New Frame Below Secure Handling) */}
          <div className="timely-frame">
            <h3 className="timely-title">Timely Delivery</h3>
            <p className="timely-text">
              Count on us for prompt and reliable <br />delivery that keeps you on track.
            </p>
          </div>

          {/* Free Template Frame (New) */}
          <div className="template-frame">
            <h3 className="template-title">Free Template</h3>
            <p className="template-text">
              Finetuned template to your needs <br />whatsoever.
            </p>
          </div>
        </div>
        </div>
    </section>
  );
};

export default AboutNextSection;
